import React from 'react';
import { Outlet } from 'react-router';
export function NonSecureLayout() {
    return <div>
        <Outlet />
    </div>
}